import React from 'react';

const PageNotFound = () => {
  return (
   <p style={{fontStyle:'italic', padding: 20}}><b>404</b>. This link is broken.<br/>Please contact administrator. </p>
  )
}

export default PageNotFound